import React from 'react';
import { Box } from '@mui/material';

const FormFooter = ({ children }: { children: React.ReactNode }) => (
  <Box sx={{ mt: { xs: 6, lg: 7 } }}>{children}</Box>
);
export default FormFooter;
